export default "334d04dcd714b1fd42f83fb98df974bf.svg";